"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = __importDefault(require("src/utilities/styled/color"));
var borderMap = {
    all: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border: " + size + " " + type + " " + color + ";\n  ";
    },
    horizontal: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border-top: " + size + " " + type + " " + color + ";\n    border-bottom: " + size + " " + type + " " + color + ";\n  ";
    },
    vertical: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border-left: " + size + " " + type + " " + color + ";\n    border-right: " + size + " " + type + " " + color + ";\n  ";
    },
    top: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border-top: " + size + " " + type + " " + color + ";\n  ";
    },
    right: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border-right: " + size + " " + type + " " + color + ";\n  ";
    },
    bottom: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border-bottom: " + size + " " + type + " " + color + ";\n  ";
    },
    left: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border-left: " + size + " " + type + " " + color + ";\n  ";
    },
};
var getDefaults = function (palette) { return ({ color: palette.border[0], size: '1px', side: 'all', type: 'solid' }); };
exports.default = (function (_a) {
    var theme = _a.theme, border = _a.border;
    var palette = theme.palette;
    if (typeof border === 'boolean') {
        if (border === true) {
            return borderMap.all(getDefaults(palette));
        }
    }
    if (typeof border === 'string') {
        if (border in borderMap) {
            return borderMap[border](getDefaults(palette));
        }
    }
    if (typeof border === 'object') {
        var _b = border.side, side = _b === void 0 ? 'all' : _b, color = border.color;
        return (side in borderMap &&
            borderMap[side](__assign(__assign(__assign({}, getDefaults(palette)), border), { color: color ? (0, color_1.default)({ theme: theme, color: color }) : palette.border[0] })));
    }
    return '';
});
